import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useEmptyKeyLockerBoxMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async keylocker_box_id => {
      await ApiInstance.post("/dashboard/admin/empty_box", { keylocker_box_id }, ENV.keylockerBaseURL);
    },
    onSuccess: keylocker_box_id => {
      const keyLockerBoxes = typedQueryClient.getQueryData(KeyLockersQueryKeys.keyLockerDetails);
      if (!keyLockerBoxes) return;

      const keyLockerBoxIdx = keyLockerBoxes.findIndex(keyLockerBox => keyLockerBox.id === keylocker_box_id);
      if (keyLockerBoxIdx === -1) return;

      const selectedKeyLockerBox = keyLockerBoxes[keyLockerBoxIdx];

      typedQueryClient.setQueryData(
        KeyLockersQueryKeys.keyLockerDetails,
        keyLockerBoxes.with(keyLockerBoxIdx, { ...selectedKeyLockerBox, is_empty: true, appointment: undefined, appointment_id: null, keylocker_communication_id: null })
      );

      const keyLockers = typedQueryClient.getQueryData(KeyLockersQueryKeys.keyLockers);
      if (!keyLockers) return;

      const keyLockerIdx = keyLockers.findIndex(keyLocker => keyLocker.id === selectedKeyLockerBox.keylocker_id);
      if (keyLockerIdx === -1) return;

      const keyLocker = keyLockers[keyLockerIdx];
      typedQueryClient.setQueryData(KeyLockersQueryKeys.keyLockers, keyLockers.with(keyLockerIdx, { ...keyLocker, key_count: keyLocker.key_count - 1 }));
    }
  });
